// src/components/BoardPackConfiguration/pages/kpi_enforcement_table.jsx
import React, { useState, useEffect, useRef } from "react";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import { useQueue } from "@/context/QueueContext";
import KPIMonthlyPerformanceTable from "@/components/BoardPack/components/tables/KPIMonthlyPerformanceTable";

const KpiEnforcementTable = ({ year = "", month = "", monthNumber = "", contract = "", page = null }) => {
    const { enqueue } = useQueue();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [tableData, setTableData] = useState({ years: [], rows: [], month: "" });
        const hasFetchedRef = useRef(false);
    

    useEffect(() => {
    //   if (!year || !month || !contract) return;
    //   if (hasFetchedRef.current) return;
    
    //   hasFetchedRef.current = true;
      fetchKPIData();
    }, [year, month, contract]);
       const fetchKPIData = async () => {
            try {
                setLoading(true);
                setError(null);

                const response ={
    "success": true,
    "errorCode": 0,
    "message": "data fetched successfully",
    "meta": {
        "contract": "0020018",
        "year": 2025,
        "years": [
            2023,
            2024,
            2025
        ],
        "month": "Dec",
        "value_type": 1,
        "measure": 1
    },
    "mdx": "SELECT CROSSJOIN( CROSSJOIN( { [Year].[2023], [Year].[2024], [Year].[2025] }, { [Months].[Dec] } ), { [Action].[CNS], [Action].[Total Escalated], [Action].[TOW], [Action].[CLAMP], [Action].[NACT], [Action].[Storage] } ) ON COLUMNS, { [Enforcement_KPI_Measures].[Working_Days], [Enforcement_KPI_Measures].[Count], [Enforcement_KPI_Measures].[Escalated], [Enforcement_KPI_Measures].[Escalation Rate], [Enforcement_KPI_Measures].[Paid Count], [Enforcement_KPI_Measures].[CN Paid Rate], [Enforcement_KPI_Measures].[CN Cancelled], [Enforcement_KPI_Measures].[CN Cancelled (Current Period)], [Enforcement_KPI_Measures].[CN Cancelled (Prior Period)], [Enforcement_KPI_Measures].[Net Count], [Enforcement_KPI_Measures].[Revenue], [Enforcement_KPI_Measures].[Average Value of CN], [Enforcement_KPI_Measures].[Closed Jobs\\Jobs Lost], [Enforcement_KPI_Measures].[Jobs Lost %], [Enforcement_KPI_Measures].[Jobs Not Enforced], [Enforcement_KPI_Measures].[Jobs Non-Enforced %], [Enforcement_KPI_Measures].[Revenue Lost NACT Items], [Enforcement_KPI_Measures].[EOs/Drivers Employed], [Enforcement_KPI_Measures].[EOS/Drivers Deployed], [Enforcement_KPI_Measures].[% Deployed to Employed], [Enforcement_KPI_Measures].[Average Jobs Per day], [Enforcement_KPI_Measures].[Estimated Drivers Shortfall], [Enforcement_KPI_Measures].[Average CNs Per Officer Per day], [Enforcement_KPI_Measures].[Average CNs Per Officer Per Hour] } ON ROWS FROM [KPI_Enforcement] WHERE ( [Payment Method Way].[Total Payment Method Way], [Version].[Actual], [CC_Contract].[0020018], [Employee].[Total Employee] )",
    "data": {
        "Working_Days": {
            "2023": {
                "Dec": {
                    "CNS": "31",
                    "Total Escalated": "31",
                    "TOW": "31",
                    "CLAMP": "31",
                    "NACT": "31",
                    "Storage": "31"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "31",
                    "Total Escalated": "31",
                    "TOW": "31",
                    "CLAMP": "31",
                    "NACT": "31",
                    "Storage": "31"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "31",
                    "Total Escalated": "31",
                    "TOW": "31",
                    "CLAMP": "31",
                    "NACT": "31",
                    "Storage": "31"
                }
            }
        },
        "Count": {
            "2023": {
                "Dec": {
                    "CNS": "1,350",
                    "Total Escalated": "1,352",
                    "TOW": "1,342",
                    "CLAMP": "10",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "1,285",
                    "Total Escalated": "1,285",
                    "TOW": "1,277",
                    "CLAMP": "8",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "986",
                    "Total Escalated": "986",
                    "TOW": "970",
                    "CLAMP": "16",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Escalated": {
            "2023": {
                "Dec": {
                    "CNS": "1,352",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "1,285",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "986",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Escalation Rate": {
            "2023": {
                "Dec": {
                    "CNS": "100.15%",
                    "Total Escalated": "100.00%",
                    "TOW": "99.26%",
                    "CLAMP": "0.74%",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "100.00%",
                    "Total Escalated": "100.00%",
                    "TOW": "99.38%",
                    "CLAMP": "0.62%",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "100.00%",
                    "Total Escalated": "100.00%",
                    "TOW": "98.38%",
                    "CLAMP": "1.62%",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Paid Count": {
            "2023": {
                "Dec": {
                    "CNS": "1,309",
                    "Total Escalated": "1,309",
                    "TOW": "1,309",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "1,298"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "1,199",
                    "Total Escalated": "1,197",
                    "TOW": "1,197",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "910"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "894",
                    "Total Escalated": "894",
                    "TOW": "894",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "785"
                }
            }
        },
        "CN Paid Rate": {
            "2023": {
                "Dec": {
                    "CNS": "96.96%",
                    "Total Escalated": "96.82%",
                    "TOW": "97.54%",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "93.31%",
                    "Total Escalated": "93.15%",
                    "TOW": "93.74%",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "90.67%",
                    "Total Escalated": "90.67%",
                    "TOW": "92.16%",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "CN Cancelled": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "CN Cancelled (Current Period)": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "CN Cancelled (Prior Period)": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Net Count": {
            "2023": {
                "Dec": {
                    "CNS": "1,350",
                    "Total Escalated": "1,352",
                    "TOW": "1,342",
                    "CLAMP": "10",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "1,285",
                    "Total Escalated": "1,285",
                    "TOW": "1,277",
                    "CLAMP": "8",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "986",
                    "Total Escalated": "986",
                    "TOW": "970",
                    "CLAMP": "16",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Revenue": {
            "2023": {
                "Dec": {
                    "CNS": "409,348",
                    "Total Escalated": "227,652",
                    "TOW": "227,652",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "139,516"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "293,261",
                    "Total Escalated": "336,174",
                    "TOW": "336,174",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "98,402"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "267,783",
                    "Total Escalated": "197,217",
                    "TOW": "197,217",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "86,402"
                }
            }
        },
        "Average Value of CN": {
            "2023": {
                "Dec": {
                    "CNS": "313",
                    "Total Escalated": "487",
                    "TOW": "487",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "107"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "245",
                    "Total Escalated": "526",
                    "TOW": "526",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "108"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "300",
                    "Total Escalated": "520",
                    "TOW": "520",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "110"
                }
            }
        },
        "Closed Jobs\\Jobs Lost": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Jobs Lost %": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Jobs Not Enforced": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Jobs Non-Enforced %": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Revenue Lost NACT Items": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "EOs/Drivers Employed": {
            "2023": {
                "Dec": {
                    "CNS": "9",
                    "Total Escalated": "14",
                    "TOW": "9",
                    "CLAMP": "5",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "9",
                    "Total Escalated": "14",
                    "TOW": "9",
                    "CLAMP": "5",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "8",
                    "Total Escalated": "14",
                    "TOW": "8",
                    "CLAMP": "6",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "EOS/Drivers Deployed": {
            "2023": {
                "Dec": {
                    "CNS": "6",
                    "Total Escalated": "6",
                    "TOW": "6",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "6",
                    "Total Escalated": "7",
                    "TOW": "6",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "6",
                    "Total Escalated": "7",
                    "TOW": "6",
                    "CLAMP": "1",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "% Deployed to Employed": {
            "2023": {
                "Dec": {
                    "CNS": "66.67%",
                    "Total Escalated": "42.86%",
                    "TOW": "66.67%",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "66.67%",
                    "Total Escalated": "50.00%",
                    "TOW": "66.67%",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "75.00%",
                    "Total Escalated": "50.00%",
                    "TOW": "75.00%",
                    "CLAMP": "16.67%",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Average Jobs Per day": {
            "2023": {
                "Dec": {
                    "CNS": "44",
                    "Total Escalated": "44",
                    "TOW": "43",
                    "CLAMP": "0",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "41",
                    "Total Escalated": "41",
                    "TOW": "41",
                    "CLAMP": "0",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "32",
                    "Total Escalated": "32",
                    "TOW": "31",
                    "CLAMP": "1",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Estimated Drivers Shortfall": {
            "2023": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "-",
                    "Total Escalated": "-",
                    "TOW": "-",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Average CNs Per Officer Per day": {
            "2023": {
                "Dec": {
                    "CNS": "7",
                    "Total Escalated": "7",
                    "TOW": "7",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "7",
                    "Total Escalated": "6",
                    "TOW": "7",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "5",
                    "Total Escalated": "5",
                    "TOW": "5",
                    "CLAMP": "1",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        },
        "Average CNs Per Officer Per Hour": {
            "2023": {
                "Dec": {
                    "CNS": "1",
                    "Total Escalated": "1",
                    "TOW": "1",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2024": {
                "Dec": {
                    "CNS": "1",
                    "Total Escalated": "1",
                    "TOW": "1",
                    "CLAMP": "-",
                    "NACT": "-",
                    "Storage": "-"
                }
            },
            "2025": {
                "Dec": {
                    "CNS": "1",
                    "Total Escalated": "1",
                    "TOW": "1",
                    "CLAMP": "0",
                    "NACT": "-",
                    "Storage": "-"
                }
            }
        }
    },
    "is_cfo": false
}

                if (!response?.success) {
                    throw new Error(response?.message || "API returned unsuccessful response");
                }

                if (response?.success && response?.data && response?.meta) {
                    const { data, meta } = response;
                    const { years, month } = meta;

                    // Get unique columns from the first year's first metric
                    const firstMetric = Object.keys(data)[0];
                    const firstYear = years[0].toString();
                    const columns = Object.keys(data[firstMetric][firstYear][month]);

                    // Build year structure dynamically
                    const yearStructure = years.map(year => ({
                        year: year.toString(),
                        columns: columns
                    }));

                    // Transform data to rows
                    const transformedRows = Object.keys(data).map(metricKey => {
                        const metricData = data[metricKey];
                        const label = metricKey.replace(/_/g, ' ').replace(/\\/g, '/');

                        const values = [];
                        years.forEach(year => {
                            const yearStr = year.toString();
                            const monthData = metricData[yearStr]?.[month] || {};
                            columns.forEach(col => {
                                values.push(monthData[col] || "-");
                            });
                        });

                        return { label, values };
                    });

                    setTableData({
                        years: yearStructure,
                        rows: transformedRows,
                        month: month
                    });
                }
            } catch (err) {
                console.error("KPI fetch error:", err);
                setError(err.message || "Failed to load data. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

         if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchKPIData} />;
  }

    return (
        <KPIMonthlyPerformanceTable
            tableData={tableData}
            loading={loading}
            error={error}
            page={page}
        />
    );
};

export default KpiEnforcementTable;